import React from 'react';
import { useLocale } from '@/i18n/LocaleContext';

export const Marquee = () => {
  const { t } = useLocale();
  const line = t.marquee;

  const Row = ({ hidden }) => (
    <div className="flex items-center" aria-hidden={hidden ? 'true' : undefined}>
      {line.map((text, i) => (
        <span key={`${text}-${i}`} className="flex items-center whitespace-nowrap">
          <span className="px-6 text-sm sm:text-base font-semibold text-primary-foreground">{text}</span>
          <span className="text-primary-foreground/50 select-none" aria-hidden="true">
            {'\u25C6'}
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="marquee-strip"
      className="relative border-y-4 border-ink bg-primary py-3 overflow-hidden"
      role="marquee"
      aria-label={line.join(' ')}
    >
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
};
